import { useApi } from "utils"
import { BillAdjustmentList, SuccessFetch, PaginationData } from "../types/billAdjustmentTypes"
import { billListStore } from "./billListStore"

export function useBillList() {
    const {
        filter,
        pagination_data,
        setData,
        setIsLoading,
        setPaginationData,
    } = billListStore()

    const api = useApi()

    const fetchData = () => {
        setIsLoading(true)
    
        const params = {
            start_date: filter.DateFrom,
            end_date: filter.DateEnd,
            bill_status: filter.bill_status,
            search_key: filter.search,
            page: pagination_data.page,
            limit: pagination_data.limit,
            size: pagination_data.size
        }
      
        api.get("/probill/list_adjustment_freight", { params })
            .then((res) => {
                const response: SuccessFetch<BillAdjustmentList[], PaginationData> = res.data;
                const data = response.payload ?? [];
                setData(data);
                setPaginationData(response.pagination_data);
            })
            .catch(() => {
                setData([]);
                setPaginationData({
                    page: 1,
                    pages: 0,
                    total: 0,
                    limit:10,
                    keyword:''
                })
            })
            .finally(() => setIsLoading(false))
    }

    return {
        fetchData
    }
}